import React from "react";
import styled from "styled-components";
import media from "styled-media-query";

// Styles
import { getFontWeight } from "../../../styles/font-weight";
import { colors } from "../../../styles/colors";

export const Footer = () => {
  return (
    <StyledDivFeatures3>
      <StyledImgLogo src={require("../../../assets/images/logo-no-background.png")} />
      <StyledDivSnsIcons>
        <StyledSnsLink>
          <NoneStyleLink href="https://www.facebook.com/pages/category/Shopping---Retail/MisakyTokyo-111148273717151/">
            facebook
          </NoneStyleLink>
        </StyledSnsLink>
        <StyledSnsLink>
          <NoneStyleLink href="https://www.instagram.com/misaky.tokyo/">instagram</NoneStyleLink>
        </StyledSnsLink>
        <StyledSnsLink>
          <NoneStyleLink href="https://www.tiktok.com/@misaky.tokyo?lang=ja">tiktok</NoneStyleLink>
        </StyledSnsLink>
      </StyledDivSnsIcons>
    </StyledDivFeatures3>
  );
};

const StyledDivFeatures3 = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${colors.logo_green};
  color: ${colors.white};
  ${getFontWeight("Heavy")};

  ${media.lessThan("small")`
    height: 120px;
  `};

  ${media.greaterThan("medium")`
    height: 200px;
  `};
`;

const StyledImgLogo = styled.img`
  ${media.lessThan("small")`
    width: 20%;
  `};

  ${media.greaterThan("medium")`
    width: 10%;
  `};
`;

const StyledDivSnsIcons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: 100vw;
  margin-top: 8px;
`;

const StyledSnsLink = styled.div`
  width: 90vw;
  text-align: left;
  font-size: 20px;

  ${media.lessThan("small")`
    font-size: 10px;
  `};
`;

const NoneStyleLink = styled.a`
  color: white;
  text-decoration: none;
`;
